import { DataService } from './../../../shared/services/dataservice.services';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ILoginDetails, IUser, User} from '../../models/user.model';
import { UserService } from '../../services/user.service';
import { LocalStorageService } from 'ngx-webstorage';
import { MessageService } from 'primeng/api';

import { Subject } from "rxjs";
import { HostListener } from '@angular/core';
import { SharedService } from '../../../shared/services';
import { emailWithWhitespaceValidator } from './../../../shared/validators'
import { CaptchaComponent } from '../../../captcha/captcha/captcha.component';
import { DVMSSystemAlertsService } from 'src/app/admin/services';
import { DvmsSystemAlertDisplayPages } from 'src/app/shared/enums/EnumsVMS';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls:['./login.component.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  
  loginForm: FormGroup;
  loginUForm: FormGroup;
  displayModal: boolean;
  userName:string;
  profileUser: User;
  IsDisplay= false;
  errorMessage: any;
  IsEnterKeyPressed:boolean=false;
  loginUserDetails: any;
  isFloatingContact: boolean =false;
  isAlertBanner:boolean = false;
  captchaConfig:any = {
    type:1, 
    length:6, 
    cssClass:'custom',
    back: {
     stroke:"#0564c2",
     solid:"#343a40"
    } , 
    font:{
      color:"#ffffff", 
      size:"25px",
      //family: 'Comic Sans MS'
    }
  };
  captchaCodeValue = null;
  showAlertMessage;
  alertMessage;
  @ViewChild(CaptchaComponent) captchaComponent: CaptchaComponent; 
  constructor(
    private _formBuilder: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService,
    private _storage: LocalStorageService,
    private _messageService: MessageService,
    private dataService: DataService,
    public sharedService: SharedService,
    private dvmsSystemAlertsService: DVMSSystemAlertsService,
  )
  {
   
    //this.showAlert();
  
   
  }
  reloadCurrentRoute() {
   window.location.reload();
}
  ngOnInit(): void {
    this.IsDisplay =true;
    this.checkAlertMessage();
    this.dataService.getUserLoginSharedData().subscribe(data => this.loginUserDetails = data);
 //   this.reloadCurrentRoute();
    this.loginUForm = this._formBuilder.group({
      userName: ['', [emailWithWhitespaceValidator,Validators.required]]
    });
    
    this.loginForm = this._formBuilder.group({
      userName: ['', [ emailWithWhitespaceValidator,Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      companyProfileId: ['', [Validators.required, Validators.minLength(5)]],
      captcha: ['', [Validators.required, Validators.minLength(6),Validators.maxLength(6)]]
    });

    if(this.loginUserDetails != null && this.loginUserDetails != undefined){
      this.loginForm.controls.userName.setValue(this.loginUserDetails.userName);
      this.dataService.setUserLoginSharedData(null);
      this.IsDisplay = false;
    }
  }

  onCheckUserName({value}: {value:ILoginDetails}): void {
    this._userService.checkUserName(value.userName.trim())
    .subscribe(response => {
      this.userName = value.userName.trim();
      this.loginForm.controls.userName.setValue(this.userName);
      this.IsDisplay = false;
      this.errorMessage = "";
      this.IsEnterKeyPressed=true;
    }, err => {
      //console.log(err.error);
      this.errorMessage = err.error.message;
      if(err.error.message == 'Username not found.')
      {
        if(err.error.message != null){
          this._messageService.clear()
        }
        this.errorMessage = err.error.message;
        //this._messageService.add({severity:'error', summary: 'Error', detail: "Username not found. Please verify login credentials."});
        this._messageService.add({severity:'error', summary: 'Error', detail: "Username not found. Please verify your email."});
        
      }
      if(err.error.message == 'The vendor associated with this email has been denied access at this time.')
      {
        this.errorMessage = err.error.message;
        this._messageService.add({severity:'error', summary: 'Error', detail: err.error.message});
      }

      if(err.error.message == 'Your UserProfile Submitted.!' || err.error.message == 'Your UserProfile In Review.!')
      {
        this._router.navigate(['/registration-status',{message:err.error.message}]);
      }
      else if(err.error.message==='Your UserProfile Not Approved.!' || err.error.message ==='Your UserProfile Not Activated.!'){
        this.userName = value.userName.trim();
        this._userService.verifyCompanySubmit(value.userName.trim()).subscribe((data:any) =>{
          //console.log(data);
          if(data.message=="Rejected") {
            this._messageService.add({severity:'error', summary: 'Error', detail: "Your Company was Rejected"});
          }
          if(data.message=="Resubmit") {
            this._router.navigate(['/register-profile',{userName:this.userName}]);
          }
          if(err.error.message ==='Your UserProfile Not Activated.!')
          {
            this._messageService.add({severity:'error', summary: 'Error', detail: "Your user profile is not activated"});
          }
        });
      }
    }
  );
  }

  onUserLogin({ value }: { value: ILoginDetails }): void {
    if (value.captcha === this.captchaCodeValue) {
      //console.log(value);
      value.userName = value.userName.trim();
      value.password = value.password.trim();
      value.companyProfileId = value.companyProfileId.trim();
      this._userService
        .attemptAuth('login', value)
        .subscribe(response => {
          this.updateLoginOnSuccess(response),
            response => this.updateLoginOnError(response);
        }
          , err => {
            if (err.reason == 'First Login Attempt') {
              var loginData = {
                userName: value.userName.trim(),
                password: value.password.trim()
              }
              this.dataService.setUserLoginSharedData(loginData);
              this._router.navigate(['users/new-user-change-password']);
            }
            else {
              this._messageService.add({ severity: 'error', summary: 'Error', detail: err.reason });
              this.resetCaptch();
            }
          }
        );

    }
    else{
      this._messageService.add({ severity: 'error', summary: 'Error', detail: "Please enter valid captacha" });
      this.resetCaptch();
    }


  }

    private updateLoginOnSuccess(response) {

    this._userService.currentUser.subscribe((userData) => {
      this.profileUser = userData;
      /*console.log('userData');
      console.log(userData);*/
      this.dataService.changeuserprofilename(userData.firstname + ' ' + userData.lastname);
    });
    var loggedInUserRole = this.sharedService.getLoggedInUserRoles();
    if(loggedInUserRole=="Super Admin"||loggedInUserRole=="VMS Analyst"||loggedInUserRole=="Admin"||loggedInUserRole=="Guest")
    {
      this._router.navigateByUrl('/dashboard');
    }
    else
    {
      this._router.navigateByUrl('/dashboard/vendor');
    }
 
  }

  private updateLoginOnError(response) {
        
    
    return false;
 
  }

  showError() {
    this._messageService.add({severity:'error', summary: 'Error', detail: 'Message Content'});
  }

  public errorHandling = (control: string, error: string) => {
    return this.loginForm.controls[control].hasError(error);
  }
  get loginFormControl() {
    return this.loginForm.controls;
  }

  public errorHandlingUserName = (control: string, error: string) => {
    return this.loginUForm.controls[control].hasError(error);
  }
  get loginUFormControl() {
    return this.loginUForm.controls;
    //console.log(this.loginUForm.controls);
  }

  @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {
      if (this.loginUForm.valid && event.key == 'Enter') {
          if(this.IsEnterKeyPressed==true && this.loginForm.valid)
          {
            this.onUserLogin(this.loginForm);
          }
          else
          {
            this.onCheckUserName(this.loginUForm);
          }
        }

    }

    forgetPassword(){
      var data = {
        userName:this.loginUForm.get('userName').value
      }
      this.dataService.setSharedData(data);
      this._router.navigate(['/forget-password']);
    }
    showContact(){
      this.isFloatingContact = (this.isFloatingContact ? false : true)
    }
    showAlert(){
      this.isAlertBanner = true;
    }

    resetCaptch() {
      this.captchaComponent.createCaptcha();
      this.loginForm.controls['captcha'].setValue('');
    }

    captchaCode(e){
      this.captchaCodeValue = e;
    }
    
    checkAlertMessage()
    {
      this._userService.checkDvmsSystemAlertByPageId(DvmsSystemAlertDisplayPages.LoginPage).subscribe((data:any)=>{
        if(data.hasAlertAvailable == true)
        {
          this.showAlertMessage = true;
          this.alertMessage = data.alertMessage;
        }
      }); 
    }
      
}
